import React from "react";
import { Dialog, Box, IconButton, Typography, Button, Stack, Avatar } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Crown from "../../assets/images/users/crown";

import { motion, AnimatePresence } from "framer-motion";


const Upgrade_popup = ({ open, onClose, data }) => {
const parsedData = {
  ...data,
  plans: data.plans.map(plan => ({
    ...plan,
    featureTwo: typeof plan.featureTwo === "string" ? JSON.parse(plan.featureTwo) : plan.featureTwo,
  })),
};
data=parsedData;
    return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: { xs: '100vw', sm: '70vw' },
          height: { xs: '90vh', sm: '80vh' },
          maxWidth: 'none',
          maxHeight: 'none',
          borderRadius: 3,
          overflow: 'hidden',
          // border: '2.5px solid gold',
          boxSizing: 'border-box',
          p: 0,
          background: "radial-gradient(ellipse at top right, #1f2020ff 40%, #7e7d7dff 80%)"
        },
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          pointerEvents: 'none',
          zIndex: 1, // less than main content/cards (which use default z-index auto/2+)
        }}
      >
        {/* First line */}
        <Box
          sx={{
            position: 'absolute',
            width: '180%',
            height: 5,
            top: '45%',
            right: '-40%',
            transform: 'rotate(-28deg)',
            background: 'linear-gradient(90deg, gold, #ffe066, transparent)',
            opacity: 0.7,
            borderRadius: 2,
            zIndex: 1,
          }}
        />
        {/* Second line */}
        <Box
          sx={{
            position: 'absolute',
            width: '190%',
            height: 4,
            top: '50%',
            right: '-55%',
            transform: 'rotate(-28deg)',
            background: 'linear-gradient(90deg, gold, #ffe066, transparent)',
            opacity: 0.48,
            borderRadius: 2,
            zIndex: 1,
          }}
        />
      </Box>
      <Box sx={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column', position: 'relative', zIndex: 2 }}>
        {/* Header with crown */}
        <Box
          sx={{
            width: '100%',
            bgcolor: 'radial-gradient(ellipse at top right, #0f0c29 0%, #302b63 80%)',
            px: { xs: 2, sm: 3, md: 4 },  // smaller padding on xs, bigger on md
            py: { xs: 1, sm: 2, md: 3 },  // smaller vertical padding on xs
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            minHeight: 54,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 700,
                color: 'white',
                letterSpacing: 1,
                m: 0,
                pt: 1,
              }}
            >
              Upgrade
            </Typography>
            <Crown height={24} style={{ color: 'gold', verticalAlign: 'top' }} />
          </Box>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{ position: 'absolute', right: 18, top: 14, color: '#444' }}
          >
            <CloseIcon />
          </IconButton>
        </Box>


        {/* New section for heading and subtitle */}
        <Box sx={{ px: { xs: 4, md: 8 }, textAlign: 'center', mt: 3, mb: 2 }}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              background: "linear-gradient(90deg, #fff 10%, #e9aede 60%, #eab3fa 90%)",
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              textFillColor: 'transparent',
              fontSize: { xs: '1.2rem', sm: '2.2rem', md: '3rem' },
            }}
          >
            Choose your plan
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{ color: '#e0d3ef', fontWeight: 500, mt: 1, fontSize: { xs: 14, md: 17 } }}
          >
            Unlock endless possibilities
          </Typography>
        </Box>

        {/* Main content area - now maps through multiple plans */}
        <Box sx={{
          flex: 1,
          py: 6,
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          bgcolor: "transparent",
          pt: 1,
          gap: { xs: 2, sm: 3 },
          flexWrap: "wrap",
          overflow: "auto"
        }}>
          {data.plans.map((plan) =>
            plan.id === 2 ? (
              <Box
                key={plan.id}
                sx={{
                  borderRadius: 4,
                  background: "linear-gradient(135deg, gold, #a80077, #66ff00 60%)",
                  p: '2.5px',
                  mx: 2,
                  minWidth: { xs: "90%", sm: 380 }, // full width on mobile, standard on tablet+
                  maxWidth: { xs: "90%", sm: 400 },
                }}
              >
                <Box
                  sx={{
                    background: "rgba(46, 46, 49, 0.94)",
                    borderRadius: 2,
                    p: { xs: 4, sm: 6 },
                    boxShadow: "0px 4px 32px 0px #00000021",
                    color: "#fff",
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
                    <Avatar sx={{ bgcolor: "#22224C", width: 34, height: 34, fontWeight: 700, fontSize: 18 }}>
                      {plan.name[0]}
                    </Avatar>
                    <Typography variant="h6" sx={{ fontWeight: 700, color: "#fff" }}>
                      {plan.name}
                    </Typography>
                  </Stack>
                  <Typography sx={{ mb: 3, color: "#c3c2e0" }}>{plan.featureOne}</Typography>
                  <Box component="ul" sx={{ listStyle: "none", pl: 0, mb: 3 }}>
                    {plan.featureTwo.map((feature, i) => (
                      <Stack component="li" key={i} direction="row" alignItems="center" spacing={2} sx={{ mb: 1.5 }}>
                        <CheckCircleIcon sx={{ color: "#26ffa1", fontSize: 21, mr: 1 }} />
                        <Typography variant="subtitle2" sx={{ color: "#fff", fontWeight: 500 }}>
                          {feature}
                        </Typography>
                      </Stack>
                    ))}
                  </Box>
                  <Typography variant="h2" sx={{ fontWeight: 700, color: "#fff", mb: 1, lineHeight: 1.1 }}>
                    <Box component="span" sx={{ fontSize: '1rem', verticalAlign: 'baseline', mr: 0.3 }}>
                      Rs
                    </Box>
                    {plan.price}
                  </Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={{
                      mt: 2,
                      borderRadius: 2.5,
                      textTransform: "none",
                      fontWeight: 700,
                      fontSize: 17,
                      py: 1.6,
                      bgcolor: "#FFEB3B",
                      color: "#22224C",
                      transition: "all 0.15s",
                      boxShadow: "none",
                      "&:hover": { bgcolor: "#fff977" }
                    }}
                  >
                    Get started
                  </Button>
                </Box>
              </Box>
            ) : (
              <Box
                key={plan.id}
                sx={{
                  background: "rgba(46, 46, 49, 0.94)",
                  borderRadius: 4,
                  p: { xs: 2, sm: 4 },
                  boxShadow: "0px 4px 32px 0px #00000021",
                  minWidth: { xs: "90%", sm: 380 }, // full width on mobile, standard on tablet+
                  maxWidth: { xs: "90%", sm: 400 },
                  color: "#fff",
                  mx: 2,
                }}
              >
                <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
                  <Avatar sx={{ bgcolor: "#22224C", width: 34, height: 34, fontWeight: 700, fontSize: 18 }}>
                    {plan.name[0]}
                  </Avatar>
                  <Typography variant="h6" sx={{ fontWeight: 700, color: "#fff" }}>
                    {plan.name}
                  </Typography>
                </Stack>
                <Typography sx={{ mb: 3, color: "#c3c2e0" }}>{plan.featureOne}</Typography>
                <Box component="ul" sx={{ listStyle: "none", pl: 0, mb: 3 }}>
                  {plan.featureTwo.map((feature, i) => (
                    <Stack component="li" key={i} direction="row" alignItems="center" spacing={2} sx={{ mb: 1.5 }}>
                      <CheckCircleIcon sx={{ color: "#26ffa1", fontSize: 21, mr: 1 }} />
                      <Typography variant="subtitle2" sx={{ color: "#fff", fontWeight: 500 }}>
                        {feature}
                      </Typography>
                    </Stack>
                  ))}
                </Box>
                <Typography variant="h2" sx={{ fontWeight: 700, color: "#fff", mb: 1, lineHeight: 1.1 }}>
                  <Box component="span" sx={{ fontSize: '1rem', verticalAlign: 'baseline', mr: 0.3 }}>
                    Rs
                  </Box>
                  {plan.price}
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  sx={{
                    mt: 2,
                    borderRadius: 2.5,
                    textTransform: "none",
                    fontWeight: 700,
                    fontSize: 17,
                    py: 1.6,
                    bgcolor: "#FFEB3B",
                    color: "#22224C",
                    transition: "all 0.15s",
                    boxShadow: "none",
                    "&:hover": { bgcolor: "#fff977" }
                  }}
                >
                  Get started
                </Button>
              </Box>
            )
          )}
        </Box>
      </Box>
    </Dialog>
  );
};

export default Upgrade_popup;
